interface Props {
  homeScore: number
  awayScore: number
  serviceTeam: 'home' | 'away' | null
  isMatchPoint?: { home: boolean; away: boolean }
  isSetPoint?: { home: boolean; away: boolean }
  displayMode?: 'score' | 'sets'
  className?: string
}

export default function ScoreBlock({
  homeScore, awayScore, serviceTeam,
  isMatchPoint, isSetPoint, displayMode = 'score', className = '',
}: Props) {
  const isFinalSets = displayMode === 'sets'

  return (
    <div className={`flex items-center justify-center gap-3 ${className}`}>
      {/* Score casa */}
      <div className="relative flex flex-col items-center">
        {!isFinalSets && (isMatchPoint?.home || isSetPoint?.home) && (
          <span className={`absolute -top-5 text-[10px] font-bold uppercase px-1.5 py-0.5 rounded ${
            isMatchPoint?.home ? 'bg-[#FE7200] text-white' : 'bg-yellow-400/20 text-yellow-300'
          }`}>
            {isMatchPoint?.home ? 'MP' : 'SP'}
          </span>
        )}
        {isFinalSets && (
          <span className="absolute -top-5 text-[10px] font-bold uppercase tracking-[0.2em] text-white/45">
            Set
          </span>
        )}
        <span
          className="font-display font-bold tabular-nums leading-none transition-all duration-150"
          style={{ color: isFinalSets ? 'white' : serviceTeam === 'home' ? '#FE7200' : 'white' }}
        >
          {homeScore}
        </span>
      </div>

      {/* Separatore */}
      <span className="font-display font-bold text-white/40">–</span>

      {/* Score ospite */}
      <div className="relative flex flex-col items-center">
        {!isFinalSets && (isMatchPoint?.away || isSetPoint?.away) && (
          <span className={`absolute -top-5 text-[10px] font-bold uppercase px-1.5 py-0.5 rounded ${
            isMatchPoint?.away ? 'bg-red-500 text-white' : 'bg-yellow-400/20 text-yellow-300'
          }`}>
            {isMatchPoint?.away ? 'MP' : 'SP'}
          </span>
        )}
        {isFinalSets && (
          <span className="absolute -top-5 text-[10px] font-bold uppercase tracking-[0.2em] text-white/45">
            Set
          </span>
        )}
        <span
          className="font-display font-bold tabular-nums leading-none transition-all duration-150"
          style={{ color: isFinalSets ? 'white' : serviceTeam === 'away' ? '#FE7200' : 'white' }}
        >
          {awayScore}
        </span>
      </div>
    </div>
  )
}
